import React from 'react';
import { connect } from 'react-redux';
import { fetchUsuarios, setFiltroUsuarios, userTypeIds } from '../../actions/usuariosActions';
import FiltroUsuarios from '../../components/Usuarios/FiltroUsuarios';
import BigSpinner from '../General/BigSpinner';
import UserListItem from './UserListItem';
import SafeReactPaginate from '../General/SafeReactPaginate';
import { withNavigation } from '../General/withNavigation';
import '../General/AdminListCard.css';
import PropTypes from 'prop-types';

class ListModeradores extends React.Component {
    constructor(props) {
        super(props);
        this.handlePageClick = this.handlePageClick.bind(this);
    }

    componentDidMount() {
        this.buscarUsuarios();
    }

    buscarUsuarios = (isFromFilter = false) => {
        const { idSeller, filtro, currentUserType } = this.props;

        // Force idSeller to 1 if user is Category (Type 1), as they should see users associated with the main Seller (Megatone/1)
        const isCategory = currentUserType == userTypeIds.isCategory;
        const idSellerToSend = isCategory ? 1 : idSeller;

        const nombreUsuario =
            (filtro?.nombreUsuario && String(filtro.nombreUsuario).trim().length >= 3)
                ? String(filtro.nombreUsuario).trim()
                : undefined;

        this.props.fetchUsuarios({
            idSeller: idSellerToSend,
            numeroPagina: filtro?.numeroPagina || 1,
            nombreUsuario,
            activo: filtro?.activo
        });

        if (isFromFilter) {
            this.props.setFiltroUsuarios({ ...filtro, numeroPagina: 1 });
        }
    };

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        const nuevoFiltro = { ...this.props.filtro, numeroPagina: selectedPage };

        const nombre = (nuevoFiltro?.nombreUsuario ?? "").toString().trim();
        if (nombre.length < 3) delete nuevoFiltro.nombreUsuario;
        else nuevoFiltro.nombreUsuario = nombre;

        this.props.setFiltroUsuarios(nuevoFiltro).then(() => this.buscarUsuarios());
    };

    onUsuario = (id) => {
        this.props.navigate(`/Usuarios/Editar/${id}`);
    };

    handleShowFilter = () => {
        const nuevoValor = !(this.props.filtro?.showFilter ?? true);
        this.props.setFiltroUsuarios({
            ...this.props.filtro,
            showFilter: nuevoValor
        });
    };


    goToUserNuevo = (dropdownSelect) => {
        this.props.navigate("/Usuarios/NuevoUser", {
            state: { dropdownSelect }
        });
    };

    handleReset = () => {
        const params = { nombreUsuario: "", numeroPagina: 1, showFilter: true, activo: undefined };
        this.props.setFiltroUsuarios(params).then(() => this.buscarUsuarios(true));
    };

    render() {
        const { userType, userName, usuarios, isLoading, cantidadTotal, filtro } = this.props;

        return (
            <div className="container">
                <div className="row mb-3 mb-md-4 align-items-center py-3 px-2 rounded admin-page-heading" style={{ background: 'linear-gradient(to right, #f8f9fa 0%, #fff 100%)', borderLeft: '4px solid var(--rojo-megatone, #c00)' }}>
                    <div className="col-12 col-md-6 col-lg-5">
                        <h4 className="mb-0 text-themecolor color-rojo-megatone fw-bold">Gestión de usuarios</h4>
                        <p className="small text-body-secondary mb-0 mt-1 d-none d-md-block">
                            Alta, edición y permisos de usuarios del seller{userName ? ` · ${userName}` : ""}.
                        </p>
                    </div>
                    <div className="button-group col-12 col-md-6 col-lg-7 text-md-end mt-2 mt-md-0 d-flex flex-wrap align-items-center justify-content-md-end gap-2">
                        {(userType.isAdminMod || userType.isSellerAdmin) && (
                            <div className="btn-group">
                                <button
                                    type="button"
                                    className="btn btn-sm background-rojo-megatone text-white dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <i className="fa fa-plus-circle mx-1" aria-hidden="true" />
                                    Crear usuario
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end">
                                    {userType.isAdminMod && (
                                        <li>
                                            <button
                                                type="button"
                                                className="dropdown-item d-flex align-items-center justify-content-between py-2"
                                                onClick={() => this.goToUserNuevo(2)}
                                            >
                                                <span className="d-inline-flex align-items-center">
                                                    Crear Proveedor
                                                </span>
                                                <span className="badge rounded-pill bg-light text-success border border-success-subtle">
                                                    Proveedor
                                                </span>
                                            </button>
                                        </li>
                                    )}
                                    {(userType.isAdminMod || userType.isSellerAdmin) && (
                                        <li>
                                            <button
                                                type="button"
                                                className="dropdown-item d-flex align-items-center justify-content-between py-2"
                                                onClick={() => this.goToUserNuevo(0)}
                                            >
                                                <span className="d-inline-flex align-items-center">
                                                    Crear Moderador
                                                </span>
                                                <span className="badge rounded-pill bg-light text-primary border border-primary-subtle">
                                                    Moderador
                                                </span>
                                            </button>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        )}

                    </div>
                </div>

                <div hidden={!(this.props.filtro?.showFilter ?? true)}>
                    <FiltroUsuarios
                        filtro={filtro}
                        fetchUsuarios={() => this.buscarUsuarios(true)}
                        handleReset={this.handleReset}
                    />
                </div>
                <div className="d-flex justify-content-center mt-1 mb-2">
                    <button
                        type="button"
                        className="btn btn-sm btn-light border d-inline-flex align-items-center gap-2 px-3 py-1"
                        onClick={this.handleShowFilter}
                        aria-expanded={this.props.filtro?.showFilter ?? true}
                        aria-label={(this.props.filtro?.showFilter ?? true) ? "Ocultar menú" : "Mostrar menú"}
                        title={(this.props.filtro?.showFilter ?? true) ? "Ocultar menú" : "Mostrar menú"}
                    >
                        <i className={`fa ${(this.props.filtro?.showFilter ?? true) ? "fa-chevron-up" : "fa-chevron-down"}`} />
                    </button>
                </div>

                {isLoading ? <BigSpinner message="Cargando moderadores..." /> :
                    <div>
                        {usuarios?.length > 0 ? (
                            <>
                                <p className="small text-body-secondary mb-2 mb-md-3">
                                    {(cantidadTotal != null && cantidadTotal !== "") && `Total: ${cantidadTotal} usuario${Number(cantidadTotal) === 1 ? "" : "s"}`}
                                    {(cantidadTotal == null || cantidadTotal === "") && `${usuarios.length} resultado${usuarios.length === 1 ? "" : "s"}`}
                                </p>
                                <div className="admin-list-stack">
                                    {usuarios.map((usuario) => (
                                        <UserListItem
                                            key={usuario.idUsuario}
                                            id={usuario.idUsuario}
                                            nombreUsuario={usuario.nombreUsuario}
                                            email={usuario.email}
                                            baja={usuario.baja}
                                            activo={usuario.activo}
                                            estado={usuario.estado}
                                            idEstado={usuario.idEstado ?? usuario.IdEstado ?? usuario.estadoId ?? usuario.EstadoId ?? usuario.idSituacion ?? usuario.IdSituacion}
                                            onRowClick={() => this.onUsuario(usuario.idUsuario)}
                                        />
                                    ))}
                                </div>
                            </>
                        ) : (
                            <output
                                className="admin-list-card p-4 p-md-5 text-center text-body-secondary"
                            >
                                <i className="fas fa-users-slash fa-2x mb-3 d-block opacity-50" aria-hidden="true" />
                                <p className="mb-1 fw-semibold text-body">No se encontraron usuarios</p>
                                <p className="small mb-0">Probá otro criterio de búsqueda o limpiá los filtros.</p>
                            </output>
                        )}
                    </div>
                }

                <div className="d-flex justify-content-center mt-3">
                    <SafeReactPaginate
                        previousLabel={"Anterior"}
                        nextLabel={"Siguiente"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={Math.ceil((cantidadTotal || 0) / 10)}
                        marginPagesDisplayed={10}
                        pageRangeDisplayed={10}
                        onPageChange={this.handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={Math.max(0, (filtro?.numeroPagina || 1) - 1)}
                    />
                </div>
            </div>
        );
    }
}
ListModeradores.propTypes = {
    // Hooks props
    navigate: PropTypes.func,
    // Redux props
    currentUserType: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    idSeller: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    filtro: PropTypes.oneOfType([PropTypes.shape({
        nombreUsuario: PropTypes.string,
        numeroPagina: PropTypes.number,
        activo: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        showFilter: PropTypes.bool,
    }), PropTypes.array]),
    usuarios: PropTypes.array,
    userName: PropTypes.string,
    cantidadTotal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    userType: PropTypes.shape({
        isAdminMod: PropTypes.bool,
        isSellerAdmin: PropTypes.bool,
    }),
    isLoading: PropTypes.bool,
    // Actions props
    fetchUsuarios: PropTypes.func,
    setFiltroUsuarios: PropTypes.func,
}

const mapStateToProps = (state) => ({
    isLoading: state.usuarios.isLoading,
    userType: state.general.userType,
    userName: state.general.userName,
    idSeller: state.general.idSeller,
    usuarios: state.usuarios.usuarios,
    filtro: state.usuarios.filtro,
    cantidadTotal: state.usuarios.cantidadTotal,
    cantidadPagina: state.usuarios.cantidadPagina,
    currentUserType: state.general.tipoUsuario
});

export default withNavigation(connect(mapStateToProps, {
    fetchUsuarios,
    setFiltroUsuarios
})(ListModeradores));
